import { useMemo } from 'react'

import { useLineChart } from './use-line-chart'

interface Props {
  dataKey: string
  render?: (point: { x: number; y: number }) => React.ReactNode
}

export const LineChartCurrentMarker: React.FC<Props> = ({ dataKey, render }) => {
  const { dataSets, xScale, yScale } = useLineChart()

  const dataSet = dataSets[dataKey]

  const currentPoint = useMemo(() => {
    let index = -1

    for (let i = dataSet.length - 1; i >= 0; i--) {
      if (dataSet[i] !== null) {
        index = i
        break
      }
    }

    const value = dataSet[index] ?? null

    if (value === null) {
      return null
    }

    const x = xScale(index)
    const y = yScale(value)

    return { x, y }
  }, [dataSet, xScale, yScale])

  if (currentPoint === null) {
    return null
  }

  return (
    <g
      key={`${currentPoint.x}${currentPoint.y}${dataSet.length}`}
      className="duration-200 animate-in fade-in slide-in-from-bottom-1"
    >
      {render ? (
        render(currentPoint)
      ) : (
        <>
          <circle cx={currentPoint.x} cy={currentPoint.y} r="6" fill="hsla(228, 55%, 42%, 0.2)" />
          <circle cx={currentPoint.x} cy={currentPoint.y} r="4" fill="hsla(228, 55%, 42%, 1)" />
        </>
      )}
    </g>
  )
}
